<app-card class="h-full w-full">
  <a
    href="https://eschool.educacionadventista.org.ar/inicio/login.php"
    target="_blank"
    class="m-4 h-full cursor-pointer rounded-lg bg-[url('/assets/images/sit/sit-finance.jpg')] bg-cover bg-center bg-no-repeat transition duration-300 hover:opacity-80"
  ></a>
</app-card>
